module.exports = __webpack_public_path__ + "img/loopindex_vdimg.44dc7a54.webp";